'use client'

import { useStoreI18n } from '@/store'
import { Typo3EventDetailItem } from '@/types/typo3/sections/spotsanity-eventlist/detail'
import Button from '@/ui/components/Button/Button'

import { memo } from 'react'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  data: Typo3EventDetailItem
}

const EventContact = ({ data }: Props) => {
  const D = useStoreI18n.use.dictionary()

  const validLinks =
    data?.links?.filter((link) => link?.href && link?.title) || []

  if (validLinks && validLinks?.length === 0) {
    return null
  }

  return (
    <div className="max-xl:col-span-2">
      <p className="textstyle-md-bold mb-2xs">{D['fe.events.links']}</p>
      <div
        className={
          'gap-xs md:gap-md flex items-start justify-start max-md:flex-col'
        }
      >
        {validLinks?.map(
          (link, index) =>
            link?.href &&
            link?.title && (
              <Button
                key={index?.toString()}
                variant="text"
                iconPosition="right"
                icon="material-symbols:open-in-new-sharp"
                nextLink={false}
                target={link?.target}
                href={link?.href}
                size="m"
              >
                {link.title}
              </Button>
            )
        )}
      </div>
    </div>
  )
}

export default memo(EventContact)
